// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"a5b7de3b","453":"40769a9c","455":"9401868c","485":"ee615de6","644":"488acf59"}[chunkId] + ".chunk.js";
};